import { render, staticRenderFns } from "./AddressActionsBox.vue?vue&type=template&id=0fff5758&"
import script from "./AddressActionsBox.vue?vue&type=script&lang=js&"
export * from "./AddressActionsBox.vue?vue&type=script&lang=js&"
import style0 from "./AddressActionsBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports